import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Firestore, doc, DocumentReference, collection, query, where, getCountFromServer } from '@angular/fire/firestore';
import { Observable, takeUntil, Subject } from 'rxjs';
import { User } from '@angular/fire/auth';
import { UserDocument } from '../../interfaces/user-document.interface';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class Home implements OnInit, OnDestroy {
  userData: UserDocument | null = null;
  private destroy$ = new Subject<void>();
  user$: Observable<User | null>;
  userDocRef: DocumentReference | null = null;
  member: boolean = false;
  showUserFunctions: boolean = false;
  stats = { plans: null as number | null, members: null as number | null };

  constructor(
    private dataService: DataService,
    private firestore: Firestore,
    public authService: AuthService,
    private router: Router,
  ) {
    this.user$ = this.authService.userSubject;
  }

  ngOnInit(): void {
    this.listenUserData();
  }

  private listenUserData(): void {
    this.dataService.userData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((userData) => {
      this.userData = userData;
      const currentAuthUser = this.authService.userSubject.getValue();

      if (userData && currentAuthUser) {
        this.userDocRef = doc(this.firestore, `User/${currentAuthUser.uid}`);
        this.loadStats(currentAuthUser.uid);
      }

      if (this.userData?.role?.includes('labhouse')) this.router.navigate(['labhouse']);
      this.member = (this.userData?.diamonds || 0) >= 5000;
    });
  }

  private async loadStats(uid: string): Promise<void> {
    try {
      const [plansSnap, membersSnap] = await Promise.all([
        getCountFromServer(collection(this.firestore, `User/${uid}/plans`)),
        getCountFromServer(query(collection(this.firestore, 'User'), where('referredBy', '==', uid))),
      ]);
      this.stats = {
        plans: plansSnap.data().count,
        members: membersSnap.data().count,
      };
    } catch {
      // stats are optional — failures are silent
    }
  }

  private closeAllChildren(): void {
    this.showUserFunctions = false;
  }

  navigateToQlyHoSo(): void { this.router.navigate(['quanLyHoSo']); }
  navigateToQlyThanhVien(): void { this.router.navigate(['quanLyThanhVien']); }
  goEventInteractionReport() { this.router.navigate(['interaction-report']); }
  navigateToNhaThuocTong(): void { this.router.navigate(['nhaThuocTong']); }

  toggleGiftersList(): void {
    if (!this.userData) { this.authService.signOut(); return; }
    this.closeAllChildren();
  }

  toggleUserFunctions(): void {
    if (!this.userData) { this.authService.signOut(); return; }
    const currentState = this.showUserFunctions;
    this.closeAllChildren();
    this.showUserFunctions = !currentState;
  }

  signOut(): void { this.authService.signOut(); }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const diamondsElement = document.getElementById('diamonds');
    const giftersDropdownElement = document.querySelector('.gifters-dropdown');
    const userFunctionsTrigger = document.querySelector('.user-functions');
    const userFunctionsDropdown = document.querySelector('.user-functions-dropdown');
    if (this.showUserFunctions && userFunctionsTrigger && !userFunctionsTrigger.contains(target) && userFunctionsDropdown && !userFunctionsDropdown.contains(target)) {
        this.showUserFunctions = false;
    }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
